import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { WorkoutAthleteResultList } from 'types';
import { client } from 'utils/api-client';

// Poll every minute so athlete-side edits flow into the staff Whiteboard.
// Mirrors the cadence baked into useMyWorkoutResult on the athlete app side.
const POLL_INTERVAL_MS = 60_000;

function useWorkoutAthleteResults(
  workoutId: string | undefined,
  // Given, the endpoint returns that athlete alone rather than the whole class.
  athleteId?: string,
  { poll = true }: { poll?: boolean } = {},
): UseQueryResult<AxiosResponse<WorkoutAthleteResultList[]>> {
  return useQuery(
    // athleteId is in the key, not just the URL: the one-athlete and class-wide reads
    // must not share a cache entry.
    ['workout-athlete-results', workoutId, athleteId],
    () => {
      const params = new URLSearchParams({ workout: workoutId ?? '' });
      if (athleteId) {
        params.set('athlete', athleteId);
      }
      return client.get<WorkoutAthleteResultList[]>(`workout-athlete-results/?${params.toString()}`);
    },
    {
      enabled: !!workoutId,
      refetchInterval: poll ? POLL_INTERVAL_MS : false,
      refetchIntervalInBackground: false,
    },
  );
}

export default useWorkoutAthleteResults;
